import { ENGINE_MATCHER_EQUAL } from '../../logger/constants';
export function equalToMatcherContext(log, ruleAttr) {
    return function equalToMatcher(runtimeAttr) {
        var isEqual = runtimeAttr === ruleAttr;
        log.debug(ENGINE_MATCHER_EQUAL, [runtimeAttr, ruleAttr, isEqual]);
        return isEqual;
    };
}
